import React from 'react';
import { useDocumentTitle } from '~/hooks';
import { Header, Page } from '../components';
import FeedbackItemsList from './FeedbackItemsList';

export default function FeedbackItems() {
  useDocumentTitle('Feedback Submissions - Admin');

  return (
    <Page>
      <Header />
      <FeedbackItemsList />
    </Page>
  );
}
